import { SubscriptionEventBanner } from '@subscriptions/presentation/components/base/SubscriptionEventBanner';
import { useSubscriptionEvents } from '@subscriptions/presentation/hooks';

/**
 * SubscriptionEventBanners - Fixed container that fetches the collection-status
 * events (`GET /v1/events`) and stacks one destructive banner per event below
 * the other. Rendered inside the domain PageLayout so it applies to every
 * subscriptions route (Resumen, Detalle, Historial de pago, Datos fiscales) but
 * never inside modals or wizards (which do not use PageLayout).
 *
 * Renders nothing while loading, on error, or when there are no events.
 */
export const SubscriptionEventBanners = () => {
  const { events } = useSubscriptionEvents();

  if (events.length === 0) {
    return null;
  }

  return (
    <div className="flex w-full flex-col gap-2 px-6 pt-4">
      {events.map((event, index) => (
        <SubscriptionEventBanner event={event} key={`${event.event}-${index}`} />
      ))}
    </div>
  );
};
